import { useEffect } from "react";

const SITE = "https://hcobnetwork.com";

function meta(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  return el;
}

// Per-route <title>, description, canonical and robots for the SPA (index.html only carries the homepage defaults).
export function useSeo({ title, description, path, robots, og, jsonLd } = {}) {
  useEffect(() => {
    const t = document.title;
    const desc = meta('meta[name="description"]', () => Object.assign(document.createElement("meta"), { name: "description" }));
    const canon = meta('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }));
    const rob = meta('meta[name="robots"]', () => Object.assign(document.createElement("meta"), { name: "robots" }));
    const prev = { desc: desc.getAttribute("content"), canon: canon.getAttribute("href"), rob: rob.getAttribute("content") };

    if (title) document.title = title;
    if (description) desc.setAttribute("content", description);
    if (path === null) canon.remove();
    else if (path !== undefined) canon.setAttribute("href", path === "/" ? SITE + "/" : SITE + path.replace(/\/+$/, ""));
    if (robots) rob.setAttribute("content", robots);
    const ogPrev = [];
    if (og) {
      for (const [prop, val] of Object.entries(og)) {
        const el = meta(`meta[property="${prop}"]`, () => { const m = document.createElement("meta"); m.setAttribute("property", prop); return m; });
        ogPrev.push([el, el.getAttribute("content")]);
        el.setAttribute("content", val);
      }
    }
    let ld = null;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.setAttribute("data-route-jsonld", "");
      ld.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }

    return () => {
      document.title = t;
      if (prev.desc) desc.setAttribute("content", prev.desc);
      if (prev.canon) { canon.setAttribute("href", prev.canon); if (!canon.isConnected) document.head.appendChild(canon); }
      if (prev.rob) rob.setAttribute("content", prev.rob);
      ogPrev.forEach(([el, val]) => { if (val) el.setAttribute("content", val); else el.remove(); });
      if (ld) ld.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, robots]);
}

export const NOINDEX = "noindex, follow";
